import { observable } from 'mobx';

const Bannerstore = observable({
  bannerRemove: false,
  curlanguage: 'kr',
});

export default Bannerstore;
